<script setup lang="ts">
import IconArrowLeft from '@patsnap-ui/icon/assets/solid/ArrowLeft.svg';
import IconArrowRight from '@patsnap-ui/icon/assets/solid/ArrowRight.svg';
import SvgIcon from '@telecom/shared/components/SvgIcon.vue';
import { useEmbodimentHistory } from './composables/use-embodiment-history';

const props = defineProps<{
    disabled?: boolean;
}>();

const { embodimentHistoryList, historyIndex, toggleNextEmbodimentHistory, togglePrevEmbodimentHistory } = useEmbodimentHistory();

function handlePrev() {
    if (props.disabled) return;
    togglePrevEmbodimentHistory();
}

function handleNext() {
    if (props.disabled) return;
    toggleNextEmbodimentHistory();
}
</script>

<template>
    <div v-if="embodimentHistoryList.length > 1" class="embodiment-generator__toggle flex items-center">
        <!-- 上一个实施例按钮 -->
        <SvgIcon
            class="th-btn-icon h-6 w-6 fill-gray-450 cursor-pointer"
            :icon="IconArrowLeft"
            @click="handlePrev"
        />
        <!-- 实施例序号/总数显示 -->
        <span class="text-gray-90 mx-1">
            {{ historyIndex + 1 }}/{{ embodimentHistoryList.length }}
        </span>
        <!-- 下一个实施例按钮 -->
        <SvgIcon
            class="th-btn-icon h-6 w-6 fill-gray-450 cursor-pointer"
            :icon="IconArrowRight"
            @click="handleNext"
        />
    </div>
</template>
